module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAABQCAIAAAC8kjOPAAAAK0lEQVR4AWP8//8/AwMDy48fP4AUExCTRv0HA1rpQ6ikrWH0V0J/ldTRBwCHF04/gGqcaAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/images/audio-bg.png
// module id = 549
// module chunks = 0